import actions from './actions';

const initState = {
    selectInfo: {},
    pillverySelects   : {
        data: []
    },
    loading : false,
    selectDeleted: false
};

export default function fetchSelectsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_SELECTS_REQUESTED:
            return {
                ...state,
                pillverySelects   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_SELECTS_SUCCEEDED:
            return {
                ...state,
                pillverySelects    : action.pillverySelects,
                loading     : false
            };
        case actions.FETCH_SELECTS_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.FETCH_SELECT_REQUESTED:
            return {
                ...state,
                selectInfo: {},
                loading : true
            };
        case actions.FETCH_SELECT_SUCCEEDED:
            return {
                ...state,
                selectInfo: action.selectData,
                loading     : false
            };
        case actions.FETCH_SELECT_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.DELETE_SELECT_REQUESTED:
            return {
                ...state,
                selectDeleted: false,
                loading : true
            };
        case actions.DELETE_SELECT_SUCCEEDED:
            return {
                ...state,
                selectDeleted: true,
                loading     : false
            };
        case actions.DELETE_SELECT_FAILED:
            return {
                ...state,
                loading : false
            };
        default:
            return state;
    }
}
